import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './style/NavBarAdmin.css';

const NavBarAdmin = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // Очистка localStorage
        localStorage.removeItem("phoneNumber");
        localStorage.removeItem("userId");
        localStorage.removeItem("userId_createdAt");
        localStorage.removeItem("adminAuth");
        localStorage.removeItem("loginTime");

        // Редирект на страницу логина
        navigate("/panel/admin-panel");
    };

    const links = [
        { path: '/panel/admin-panel', label: 'Админ панель' },
        { path: '/panel/user-management', label: 'Пользователи' },
        { path: '/panel/disc-card', label: 'Дискорд карты' },
        { path: '/panel/companies-mng-panel', label: 'Компании' },
        { path: '/panel/cars-templates-panel', label: 'Шаблоны авто' },
        { path: '/panel/service-mng-panel', label: 'Услуги' },
        { path: '/panel/orders-panel', label: 'Заказы' },
        { path: '/panel/news-admin', label: 'Новости' },
    ];

    return (
        <motion.header
            className="navbar"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
        >
            <div className="navbar-container">
                <motion.div
                    className="logo"
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                >
                    🚗 ROAD ASSIST
                </motion.div>

                <nav className="nav-links">
                    {links.map(({ path, label }) => (
                        <motion.div
                            key={path}
                            whileHover={{ scale: 1.08 }}
                            whileTap={{ scale: 0.96 }}
                            transition={{ type: 'spring', stiffness: 280 }}
                        >
                            <NavLink
                                to={path}
                                className={({ isActive }) => isActive ? 'active' : undefined}
                                end
                            >
                                {label}
                            </NavLink>
                        </motion.div>
                    ))}

                    {/* Кнопка "Выйти" */}
                    <motion.div
                        className="logout-btn"
                        whileHover={{ scale: 1.08 }}
                        whileTap={{ scale: 0.96 }}
                        transition={{ type: 'spring', stiffness: 280 }}
                        onClick={handleLogout}
                        style={{ cursor: "pointer", color: "red", fontWeight: "bold" }}
                    >
                        Выйти
                    </motion.div>
                </nav>
            </div>
        </motion.header>
    );
};

export default NavBarAdmin;
